import {
    IonContent, IonHeader, IonPage,
    IonTitle, IonToolbar, IonButtons, IonMenuButton,
    IonSearchbar, IonRefresher, IonRefresherContent, IonInfiniteScroll, IonInfiniteScrollContent
} from '@ionic/react';
import { chevronDownCircleOutline } from 'ionicons/icons';
import { useEffect, useState } from 'react';
import Referrals from '../components/Referrals';
import { doReload } from '../hooks/common';
import useNavigation from '../hooks/useNavigation';
import { getReferrals } from '../services/referral.service';
// debounce hook
import useDebounce from "../hooks/useDebounce";
import CustomSearchBox from '../components/CustomSearchBox/CustomSearchBox';

const ReferralList: React.FC = () => {
    const [searchText, setSearchText] = useState('');
    const [disableInfiniteScroll, setDisableInfiniteScroll] = useState<boolean>(false);
    const [skip, setSkip] = useState<number>(20);
    const navigateTo = useNavigation();
    const debounceSearchText = useDebounce(searchText, 1000);

    const [referrals, setReferrals] = useState([] as any[]);
    useEffect(() => {
        let mounted = true;
        getReferrals(debounceSearchText)
            .then(items => {
                if (mounted) {
                    setReferrals(items);
                }
            });
        return () => { mounted = false };
    }, [debounceSearchText]);

    async function fetchNext($event: CustomEvent<void>) {
        setSkip(skip + 20);
        getReferrals(debounceSearchText, skip)
            .then(items => {
                if (items?.length > 0) {
                    setReferrals([...referrals, ...items]);
                    setDisableInfiniteScroll(items.length < 20);
                } else {
                    setDisableInfiniteScroll(true);
                }
                ($event.target as HTMLIonInfiniteScrollElement).complete();
            });
    }

    return (
        <IonPage>
            <IonHeader>
                <IonToolbar>
                    <IonButtons slot="start">
                        <IonMenuButton />
                    </IonButtons>
                    <IonTitle>Referrals</IonTitle>
                </IonToolbar>
                <CustomSearchBox setSearchText={setSearchText} />
            </IonHeader>
            <IonContent>
                <IonRefresher slot="fixed" onIonRefresh={doReload}>
                    <IonRefresherContent
                        pullingIcon={chevronDownCircleOutline}
                        pullingText="Pull to refresh"
                        refreshingSpinner="circles"
                        refreshingText="Refreshing...">
                    </IonRefresherContent>
                </IonRefresher>
                <Referrals referrals={referrals} />
                <IonInfiniteScroll threshold="100px"
                    disabled={disableInfiniteScroll}
                    onIonInfinite={(e: CustomEvent<void>) => fetchNext(e)}>
                    <IonInfiniteScrollContent
                        loadingText="Loading more...">
                    </IonInfiniteScrollContent>
                </IonInfiniteScroll>
            </IonContent>
        </IonPage>
    );
};

export default ReferralList;
